/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".botones-container[_ngcontent-%COMP%]{margin-left:20px;margin-right:20px}"];
export { styles as styles };
